"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Popup = _interopRequireDefault(require("../Popup"));

var _Button = _interopRequireDefault(require("./Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var OptionsButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(OptionsButton, _Component);

  var _super = _createSuper(OptionsButton);

  function OptionsButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionsButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(OptionsButton, [{
    key: "renderButton",
    value: function renderButton() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? "CIRCULAR" : _this$props$type,
          _this$props$padding = _this$props.padding,
          padding = _this$props$padding === void 0 ? "7px" : _this$props$padding,
          buttonTitle = _this$props.buttonTitle;

      if (buttonTitle != null) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: (0, _styling.css)(className, style),
          padding: padding
        }, typeof buttonTitle == "string" ? buttonTitle : buttonTitle());
      }

      if (type == "CIRCULAR") {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(this.styles.root, style, className)
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: icons.ellipseV,
          className: (0, _styling.css)(this.styles.ellipseV),
          alt: "ellipse vertical"
        }));
      } // type == "RECTANGULAR"


      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: (0, _styling.css)(className, style),
        padding: padding
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "ellipseV",
        className: (0, _styling.css)(this.styles.ellipseVRectangular)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          popoverPosition = _this$props2.popoverPosition,
          className = _this$props2.className,
          style = _this$props2.style;

      if (options.length === 0) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(className, style)
      }, /*#__PURE__*/_react["default"].createElement(_Popup["default"], {
        trigger: this.renderButton(),
        position: popoverPosition,
        on: ["click"]
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.optionsList)
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(option.disabled ? _this2.styles.optionInactive : _this2.styles.optionActive),
          key: "option_".concat(option.title),
          onClick: option.disabled ? undefined : option.onClick
        }, option.icon && /*#__PURE__*/_react["default"].createElement("img", {
          src: option.icon,
          alt: option.title,
          draggable: false,
          className: (0, _styling.css)(_this2.styles.icon)
        }), option.title);
      }))));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          surface = _this$context$theming2.surface,
          borderPrimary = _this$context$theming2.borderPrimary,
          primary = _this$context$theming2.primary,
          textBlack = _this$context$theming2.textBlack,
          fonts = _this$context$theming.fonts;
      var option = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: surfaceLightest,
        padding: "8px 15px",
        minWidth: 150,
        fontSize: 14,
        fontFamily: fonts.regular,
        userSelect: "none",
        whiteSpace: "nowrap",
        borderBottom: "1px solid ".concat(borderPrimary),
        ":last-child": {
          borderBottom: "none"
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          userSelect: "none",
          transition: "all 0.2s linear",
          opacity: 0.8,
          width: 40,
          height: 40,
          backgroundColor: surfaceLightest,
          ":hover": {
            opacity: 1,
            backgroundColor: surface
          },
          borderRadius: "50%"
        },
        optionsList: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          margin: "10px 0px"
        },
        optionActive: _objectSpread({
          cursor: "pointer",
          backgroundColor: surfaceLightest,
          color: textBlack,
          transition: "all 0.2s linear",
          ":hover": {
            backgroundColor: "".concat(primary, "1A"),
            // 20% transparency
            color: primary
          }
        }, option),
        optionInactive: _objectSpread({
          cursor: "default",
          opacity: 0.6
        }, option),
        ellipseV: {
          height: "60%"
        },
        ellipseVRectangular: {
          height: 16,
          width: 16
        },
        icon: {
          width: 13,
          height: 13,
          marginRight: 10
        }
      });
    }
  }]);
  return OptionsButton;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  options: {
    required: true,
    type: "ReadonlyArray<{ title: string, onClick: () => void, disabled?: boolean }>",
    description: "List of possible options"
  },
  popoverPosition: {
    required: false,
    type: "string",
    defaultValue: "bottom center",
    description: "Position of the popover that shows the options"
  },
  type: {
    required: false,
    type: "CIRCULAR | RECTANGULAR",
    defaultValue: "CIRCULAR",
    description: "Controls whether the look of the button follows the borderless " + "circular theme or the standard rectangular button theme"
  },
  padding: {
    required: false,
    type: "string",
    defaultValue: "7px",
    description: "Internal padding of the button. Only valid when type == `RECTANGULAR`"
  },
  buttonTitle: {
    required: false,
    type: "string | (() => ReactNode)",
    defaultValue: "null",
    description: "Custom button title. If this is set, the \"type\" will be ignored"
  }
}, _class3.demoProps = {
  options: [{
    title: "Edit",
    onClick: function onClick() {},
    disabled: false,
    icon: icons.edit
  }, {
    title: "Delete",
    onClick: function onClick() {},
    disabled: false,
    icon: icons.deleted
  }],
  popoverPosition: "bottom center"
}, _class3.defaultProps = {
  popoverPosition: "bottom center"
}, _class3.isCoreComponent = true, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = OptionsButton;
exports["default"] = _default;